module.exports = __webpack_public_path__ + "img/open.a0cdb18a.gif";